// Client-side hostname redirect. Anyone landing on the old greensurv.co.uk
// (or any subdomain of it) is sent to the matching path on oxford-ec.co.uk.
// This is not a true HTTP 301 — for that, configure the redirect at your
// DNS/CDN/host level (Cloudflare rule or Emergent platform). But it ensures
// no visitor ever sees the old branded URL even before a server-side rule
// is in place, and it surfaces a `data-testid` flag for any future testing.
import { useEffect } from "react";

const OLD_HOST_PATTERN = /(^|\.)greensurv\.co\.uk$/i;
const NEW_HOST = "www.oxford-ec.co.uk";

export default function HostnameRedirect() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const host = window.location.hostname.toLowerCase();
    if (OLD_HOST_PATTERN.test(host)) {
      const target = `https://${NEW_HOST}${window.location.pathname}${window.location.search}${window.location.hash}`;
      // window.location.replace doesn't push history — closest a SPA gets to a 301.
      window.location.replace(target);
    }
  }, []);
  return null;
}
